/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/pt/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/pt/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/pt/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/pt/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/pt/preview-05.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/pt/preview-06.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/pt/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      link: require('@/assets/images/township/preview/pt/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/pt/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/pt/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/pt/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/pt/preview-05.webp'),
    },
  ],
};
